import { formatTelemetryAttributes } from './format-telemetry-attributes';
import { formatTelemetryMetrics } from './format-telemetry-metrics';
export function createPageViewLog({ page, previousPage = {}, options = {}, dimensionLookup = {}, metricLookup = {}, }) {
    const metrics = formatTelemetryMetrics(options, metricLookup);
    const attributes = formatTelemetryAttributes({
        telemetryData: options,
        dimensionLookup,
        excludeKeys: [
            'workflow',
            ...Object.keys(metrics),
            ...Object.keys(metricLookup),
        ],
    });
    const { referrer, title } = document || {};
    const { hostname, pathname } = window && window.location ? window.location : {};
    return Object.assign(Object.assign({ name: 'pageView', referrer,
        hostname, path: page || pathname, pageUrl: page || pathname, pageName: title, previousPageUrl: previousPage.pageUrl, previousPageName: previousPage.pageName }, attributes), metrics);
}
//# sourceMappingURL=create-page-view-log.js.map